import { render } from "./VirtualMarketplaceComponent.vue?vue&type=template&id=44e3bfe7&scoped=true"
import script from "./VirtualMarketplaceComponent.js?vue&type=script&lang=js"
export * from "./VirtualMarketplaceComponent.js?vue&type=script&lang=js"

import "./VirtualMarketplaceComponent.scss?vue&type=style&index=0&id=44e3bfe7&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e3bfe7"]])

export default __exports__